import URI from 'urijs';
import { wrapFunc, AesEncrypt } from '../../util/js';
import { PATH_API_DEVICE, SELECT_SIZE } from '../../config';
import { CB_STATUS, cFetch } from '../../util/fetch';
import { errCB } from './auth';
import { getDomain } from '../../util/url';

export const actGetDevices = wrapFunc((dispatch, data, cb) => {
  dispatch({
    type: 'DEVICE_GET_DOING',
  });
  const urlQuery = {
    limit: SELECT_SIZE,
    offset: data.offset,
  };
  const url = URI(getDomain() + PATH_API_DEVICE)
    .query(urlQuery)
    .toString();
  return cFetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${data.token}`,
      'Accept-Language': data.lang || 'en',
    },
    credentials: 'same-origin',
  })
    .then((j) => {
      if (j.status === 200) {
        const t = j.payload.results.map((v, i) => ({
          id: i,
          SerialNumber: v.SerialNumber,
          DisplayName: v.DisplayName,
        }));
        dispatch({
          type: 'DEVICE_GET_DONE',
          payload: {
            count: j.payload.count,
            results: t,
          },
        });
        if (cb) cb({ status: CB_STATUS.SUCCESS });
      } else {
        throw j;
      }
      return j;
    })
    .catch((err) => {
      dispatch({
        type: 'DEVICE_GET_ERR',
      });
      errCB(err, dispatch, cb);
    });
}, 'actGetDevices');

export const actCreateDevice = wrapFunc((dispatch, data, cb) => {
  dispatch({
    type: 'DEVICE_CREATE_DOING',
  });
  const url = getDomain() + PATH_API_DEVICE;
  const formData = new FormData();
  // formData.append('SerialNumber', data.SerialNumber);
  // formData.append('DisplayName', data.DisplayName);
  // formData.append('DeviceType', 'Any');

  formData.append('SerialNumber', AesEncrypt(data.SerialNumber));
  formData.append('DisplayName', AesEncrypt(data.DisplayName));
  formData.append('DeviceType', AesEncrypt('Any'));

  return cFetch(url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${data.token}`,
      'Accept-Language': data.lang || 'en',
    },
    body: formData,
    credentials: 'same-origin',
  })
    .then((j) => {
      if (j.status === 201) {
        dispatch({
          type: 'DEVICE_CREATE_DONE',
        });
        if (cb) cb({ status: CB_STATUS.SUCCESS });
      } else {
        throw j;
      }
      return j;
    })
    .catch((err) => {
      dispatch({
        type: 'DEVICE_CREATE_ERR',
      });
      switch (err.status) {
        case 400:
          if (err.payload.detail === 'Invalid SerialNumber.') {
            if (cb) cb({ status: CB_STATUS.INVALID });
            break;
          }
          if (err.payload.SerialNumber !== undefined) {
            switch (err.payload.SerialNumber[0]) {
              case 'device with this SerialNumber already exists.':
                if (cb) cb({ status: CB_STATUS.EXIST, payload: 'SerialNumber' });
                break;
              default:
                break;
            }
            break;
          } else if (err.payload.DisplayName !== undefined) {
            if (cb) cb({ status: CB_STATUS.EXIST, payload: 'DisplayName' });
            break;
          } else if (err.payload[0] === 'Limit exceeded') {
            if (cb) cb({ status: CB_STATUS.MAXLIMITDevice });
            break;
          } if (err.payload[0] === 'The SerialNumber has existed.') {
            if (cb) cb({ status: CB_STATUS.EXIST, payload: 'SerialNumber' });
            break;
          } if (err.payload[0] === 'Invalid SerialNumber.') {
            if (cb) cb({ status: CB_STATUS.INVALID });
            break;
          } else {
            if (cb) cb({ status: CB_STATUS.OTHER });
            break;
          }
        default:
          errCB(err, dispatch, cb);
      }
    });
}, 'actCreateDevice');

export const actUpdateDevice = wrapFunc((dispatch, data, cb) => {
  dispatch({
    type: 'DEVICE_UPDATE_DOING',
  });
  const url = `${getDomain() + PATH_API_DEVICE + AesEncrypt(data.SerialNumber)}/`;
  const formData = new FormData();
  formData.append('DisplayName', AesEncrypt(data.DisplayName));
  return cFetch(url, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${data.token}`,
      'Accept-Language': data.lang || 'en',
    },
    body: formData,
    credentials: 'same-origin',
  })
    .then((j) => {
      if (j.status === 200) {
        dispatch({
          type: 'DEVICE_UPDATE_DONE',
        });
        if (cb) cb({ status: CB_STATUS.SUCCESS });
      } else {
        throw j;
      }
      return j;
    })
    .catch((err) => {
      dispatch({
        type: 'DEVICE_UPDATE_ERR',
      });
      switch (err.status) {
        case 400:
          if (cb) cb({ status: CB_STATUS.EXIST, payload: 'DisplayName' });
          break;
        default:
          errCB(err, dispatch, cb);
      }
    });
}, 'actUpdateDevice');

export const actDeleteDevice = wrapFunc((dispatch, data, cb) => {
  dispatch({
    type: 'DEVICE_DELETE_DOING',
  });
  const url = `${getDomain() + PATH_API_DEVICE + AesEncrypt(data.SerialNumber)}/`;

  return cFetch(url, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${data.token}`,
      'Accept-Language': data.lang || 'en',
    },
    credentials: 'same-origin',
  })
    .then((j) => {
      if (j.status === 204) {
        dispatch({
          type: 'DEVICE_DELETE_DONE',
        });
        if (cb) cb({ status: CB_STATUS.SUCCESS });
      } else {
        throw j;
      }
      return j;
    })
    .catch((err) => {
      dispatch({
        type: 'DEVICE_DELETE_ERR',
      });
      switch (err.status) {
        case 500:
          if (cb) cb({ status: CB_STATUS.FORBID });
          break;
        default:
          errCB(err, dispatch, cb);
      }
    });
}, 'actDeleteDevice');
